module.exports = __webpack_public_path__ + "enr-static/img/icon_info_g1.1e0a1b8a.svg";